import React from 'react';
import { StyleSheet, Text, View } from 'react-native';  
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { TailwindProvider } from 'tailwind-rn';
import utilities from './tailwind.json';
import NetInfo from '@react-native-community/netinfo';

//My Components
import Main from './components/Main.js';
import ResourceReader from './components/ResourceReader.js';
import MyResources from './components/MyResources.js';
import DownloadResources from './components/DownloadResources.js';
import Situacion from './components/Situacion';
import DLSitua from './components/DLSitua'; 
import JsonUploader from './components/JsonUploader';
import Tema from './components/Tema.js'

const Stack = createNativeStackNavigator();

export default function App() { 
  return (
      <NavigationContainer>
        <TailwindProvider utilities={utilities} colorScheme="light">
          <Stack.Navigator>
            <Stack.Screen name="Principal" component={Main} />
            <Stack.Screen name="Recurso" component={ResourceReader} />
            <Stack.Screen name="Mis recursos" component={MyResources} />
            <Stack.Screen name="Descargar recursos" component={DownloadResources} />
            <Stack.Screen name='Situación' component={Situacion} />
            <Stack.Screen name='Descarga de situación' component={DLSitua} />
            <Stack.Screen name='Tema' component={Tema} />
            <Stack.Screen name='Json uploader' component={JsonUploader} />
          </Stack.Navigator>
        </TailwindProvider>
      </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
